
interface ExploreHeaderProps {
  title: string;
}

const ExploreHeader = ({ title }: ExploreHeaderProps) => {
  return (
    <>
      {title}
    </>
  );
};

export default ExploreHeader;
